import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";

function Google() {
  return (
    <>
      <GoogleOAuthProvider clientId="312865778710-19lsg74dtb55fkmqb0fed2j1c5ees1e2.apps.googleusercontent.com">
        <GoogleLogin
          onSuccess={(credentialResponse) => {
           
          }}
          onError={() => {
         
          }}
        />
      </GoogleOAuthProvider>
    </>
  );
}

export default Google;
